import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMixpanelAdminType, Mixpanel } from '../../services/Mixpanel';
import TestDesignImage from "../../static/img/test-design.png";

const TestDesign = () => {
  const { userData } = useSelector(state => state.auth);

  useEffect(() => {
    Mixpanel.track("Competition_Admin_TestDesign_Viewed", {
			"Admin_Type": getMixpanelAdminType(userData?.groups),
		});
		Mixpanel.people.set({
			"$email": userData?.email,
			"$distinct_id": userData?.id
		});
  }, []);
  
  
  return <img src={TestDesignImage} style={{ width: "100%" }} alt="Test Design" />;
};

export default TestDesign;